import type { FetchOptions } from 'ofetch'

import useApiClient from './api-client'

export const putReviewLike = async (reviewId: number | string, args: FetchOptions = {}) => {
  const api = useApiClient()
  const result = await api(`/review/${reviewId}/like`, { ...args, method: 'PUT' })

  return result
}

export const deleteReviewLike = async (reviewId: number | string, args: FetchOptions = {}) => {
  const api = useApiClient()
  const result = await api(`/review/${reviewId}/like`, { ...args, method: 'DELETE' })

  return result
}
